import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    COLOR,
    paletaTonsAzul,
} from '../../../business-const/Color/Color'

import {
    GridContainer,
    GridItem1xs2,
    GridItem3,
    GridItem4,
    GridItem4sm12xs12,
    GridItem6,
    GridItem11,
    GridItem12,
 } from '../../../business-components/Grid/Grid'

 import {
    CardGrid,
    CardGridEstudo,
    CardGridDivHeaderDestaque1,
    CardGridDivH4Destaque,
    CardGridDivBody,
    CardGridDivBodyEntradaDados,
} from '../../../business-components/Card/Card'

import {
    ButtonVisualizarTabela,
} from '../../../business-components/Button/Button'

import { 
    TextFieldTextSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    pesquisaList,
    pesquisaIndexList,
} from '../../../business-rules/List/ListService'

import tipoDiagnosticoAposentadoriaChartList from '../../../business-rules/List/tipoDiagnosticoAposentadoriaChartList'

import {
    ChartPadrao
} from '../../../business-components/Chart/Chart'

import {
    relatorioModoApresentacao,
} from '../estudo-form/EstudoService'

import {
    GridContainerEstudoPadraoLg,
    IconButtonExpandMoreLessLista,
} from '../estudo-form/EstudoComp'

import {
    CustomizedDialogsPopup,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    AposentadoriaExpectativaVidaCliente,
} from '../simulacaoFinanceira-form/SimulacaoFinanceiraCompParametros'

import {
    processaValoresDefaultIniciaisDiagnosticoAposentadoriaChart,
} from './DiagnosticoAposentadoriaChartService'

import EstudoFormEvolucaoReservaFinanceiraEstudo from '../estudo-form/EstudoFormEvolucaoReservaFinanceiraEstudo'



const DiagnosticoAposentadoriaChart = ( { values, handleChange, setFieldValue, estudo, tipoDiagnosticoAposentadoriaChart,
    report, moreLessList, aiFT } ) => {
    
    processaValoresDefaultIniciaisDiagnosticoAposentadoriaChart(values)

    if (tipoDiagnosticoAposentadoriaChart) {
        values.tipoDiagnosticoAposentadoriaChart = tipoDiagnosticoAposentadoriaChart
    }

    const series = []

    const paletaCoresEspecifica = []

    estudo.current.graficoDiagnosticoAposentadoriaRecursosFinanceirosAcumulados?.forEach( (linhaGraficoDiagnosticoAposentadoriaRecursosFinanceirosAcumulados, index) => {
        
        series.push(
            {
                name: linhaGraficoDiagnosticoAposentadoriaRecursosFinanceirosAcumulados.descricao,
                type: "area",
                data: linhaGraficoDiagnosticoAposentadoriaRecursosFinanceirosAcumulados.serie,
            },
        )

        paletaCoresEspecifica.push(
            linhaGraficoDiagnosticoAposentadoriaRecursosFinanceirosAcumulados.descricao === LABEL.economiaReceitaMensal
                ?
                    COLOR().corChartPadraoAporteAposentadoriaBalancoPositivo
                :
                    paletaTonsAzul[index]
        )
    })
    
    if (values.tipoDiagnosticoAposentadoriaChart === HARDCODE.tipoDiagnosticoAposentadoriaChartSituacaoAtual) {

        series.push(
            {
                name: LABEL.liquidezFinanceiraAcumuladaSuperavit,
                type: "area",
                data: estudo.current.graficoDiagnosticoAposentadoriaLiquidezFinanceiraAcumuladaAtualSuperavit,
            },
        )

        paletaCoresEspecifica.push(
            COLOR().corChartPadraoVerde
        )

        series.push(
            {
                name: LABEL.liquidezFinanceiraAcumuladaDeficit,
                type: "area",
                data: estudo.current.graficoDiagnosticoAposentadoriaLiquidezFinanceiraAcumuladaAtualDeficit,
            },
        )

        paletaCoresEspecifica.push(
            COLOR().corChartPadraoVermelho
        )

    } else {

        series.push(
            {
                name: LABEL.liquidezFinanceiraAcumulada,
                type: "area",
                data: estudo.current.graficoDiagnosticoAposentadoriaLiquidezFinanceiraAcumuladaIdeal,
            },
        )

        paletaCoresEspecifica.push(
            COLOR().corChartPadraoVerde,
        )
    
        series.push(
            {
                name: LABEL.diagnosticoAposentadoriaDepositosParaAposentadoria,
                type: "area",
                data: estudo.current.graficoDiagnosticoAposentadoriaDepositoAcumuladoAteAposentadoria,
            },
        )

        paletaCoresEspecifica.push(
            COLOR().corChartPadraoCinza,
        )
    }

    const categories = estudo.current.graficoIdadesGraficos

    const GridItem4sm12xs12DiagnosticoAposentadoriaChart = report ? GridItem4 : GridItem4sm12xs12

    const GridGrafico = report ? GridItem11 : GridItem11

    const DiagnosticoAposentadoria = ( props ) => {

        return (
            <div
                {...props}
            >
                <GridContainer>
                    <GridGrafico>
                        <ChartPadrao
                            titleText={
                                //LABEL.diagnosticoAposentadoria + ': ' + // mudança da fonte
                                    pesquisaList(tipoDiagnosticoAposentadoriaChartList(values),
                                        values.tipoDiagnosticoAposentadoriaChart).descricao
                            }
                            type="area"
                            series={series}
                            height={aiFT ? report ? 200 : 320 : report && values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioPaisagem ? 300 : ''}
                            annotations={estudo.current.graficoRecursosFinanceirosAcumuladosAnnotations}
                            stacked={true}
                            categories={categories}
                            categories2={estudo.current.graficoAnos}
                            paletaCores={paletaCoresEspecifica}
                            dataLabelsEnabled={values.modoApresentacao}
                            dataLabelsEnabledReport={
                                values.formatoReport === HARDCODE.idFormatoReportImpressao || values.modoApresentacao
                            }
                            dataLabelsType='Idade'
                            dataLabelsInterval={15}
                            dataLabelsDestaque={[values.idadeVaiAposentarCliente]}
                            notInverseOrder={true}
                            strokeWidth={0}//0
                            toolTipX={true}
                            toolTipXTotal={true}
                            report={!aiFT && (report || relatorioModoApresentacao(values))}
                            formatoReport={values.formatoReport}
                            modoApresentacao={values.modoApresentacao}
                            fillOpacity={0.9}//0.9
                            //fillType='gradient'
                            participacao={true}
                            notLegendShow={aiFT}
                            aiFT={aiFT}
                        />
                    </GridGrafico>

                     {!report && !aiFT && values.tabClienteFormList !== LABEL.tabClienteFormListRelatorio && values.modoApresentacao && (
                        <GridContainer
                            className='justify-center mt-10'
                        >
                            <GridItem6>
                                <AposentadoriaExpectativaVidaCliente
                                    values={values}
                                    setFieldValue={setFieldValue}
                                />
                            </GridItem6>
                        </GridContainer>
                    )}
                </GridContainer>
            </div>
        )
    }



    const CardGridEstudoAux = values.modoApresentacao ? GridItem12 : CardGridEstudo

    const TipoDiagnosticoAposentadoriaChart = () => {

        return (
            <GridContainer>
                <GridItem12>
                    <TextFieldTextSelect
                        name="tipoDiagnosticoAposentadoriaChart"
                        label={LABEL.tipoDiagnosticoAposentadoriaChart}
                        value={values.tipoDiagnosticoAposentadoriaChart || ''}
                        onChange={handleChange}
                        list={tipoDiagnosticoAposentadoriaChartList(values)}
                    />
                </GridItem12>
            </GridContainer>
        )
    }

    const exibir = !moreLessList || values.modoApresentacao || values[moreLessList][pesquisaIndexList(values[moreLessList],
        HARDCODE.diagnosticoAposentadoriaChart)].expanded



    return (
        <GridItem12>
            {report || relatorioModoApresentacao(values)
                ?
                    <DiagnosticoAposentadoria
                        className='mt-5'//' ml-5'
                    />
                :
                    <GridContainerEstudoPadraoLg
                        component={
                            <div
                                className={values.modoApresentacao ? 'mt--5' : ''}
                            >
                                <CardGridEstudoAux>
                                    <CardGridDivHeaderDestaque1
                                        semBackground={values.modoApresentacao}
                                    >
                                        <GridContainer>
                                            <GridItem4sm12xs12DiagnosticoAposentadoriaChart>
                                                <CardGridDivH4Destaque>
                                                    {LABEL.diagnosticoAposentadoria}
                                                </CardGridDivH4Destaque>
                                            </GridItem4sm12xs12DiagnosticoAposentadoriaChart>
                                            
                                            <GridItem3
                                                className='mt-0'//'mt-4'
                                            >
                                                {exibir && (values.valorPresenteDeficitSimulacaoMensal === 0 ||
                                                values.tipoDiagnosticoAposentadoriaChart ===
                                                HARDCODE.tipoDiagnosticoAposentadoriaChartSituacaoAtual) && (
                                                    <CustomizedDialogsPopup
                                                        maxWidth='lg'
                                                        popupTitle={LABEL.evolucaoReservaFinanceira}
                                                        PopupButton={ButtonVisualizarTabela}
                                                        popupComponent={
                                                            <EstudoFormEvolucaoReservaFinanceiraEstudo
                                                                values={values}
                                                                estudo={estudo}
                                                                report={false}
                                                                popup={true}
                                                            />
                                                        }
                                                    />
                                                )}
                                            </GridItem3>
                                            
                                            <GridItem4sm12xs12DiagnosticoAposentadoriaChart>
                                                {exibir && values.valorPresenteDeficitSimulacaoMensal !== 0 && (
                                                    values.modoApresentacao
                                                        ?
                                                            <TipoDiagnosticoAposentadoriaChart/>
                                                        :
                                                            <CardGrid>
                                                                <CardGridDivBodyEntradaDados>
                                                                    <TipoDiagnosticoAposentadoriaChart/>
                                                                </CardGridDivBodyEntradaDados>
                                                            </CardGrid>
                                                )}
                                            </GridItem4sm12xs12DiagnosticoAposentadoriaChart>

                                            <GridItem1xs2>
                                                {!values.modoApresentacao && moreLessList &&(
                                                    <IconButtonExpandMoreLessLista
                                                        nameListaMoreLess={moreLessList}
                                                        listaMoreLess={values[moreLessList]}
                                                        idListaMoreLess={HARDCODE.diagnosticoAposentadoriaChart}
                                                        setFieldValue={setFieldValue}
                                                    />
                                                )}
                                            </GridItem1xs2>
                                        </GridContainer>
                                    </CardGridDivHeaderDestaque1>

                                    {exibir && (
                                        <CardGridDivBody>
                                            <DiagnosticoAposentadoria
                                                className='ml-10'
                                            />
                                        </CardGridDivBody>
                                    )}
                                </CardGridEstudoAux>
                            </div>
                        }
                    />
            }
        </GridItem12>
    )
}

export default DiagnosticoAposentadoriaChart